import React, { useState, useEffect } from 'react';
import './ShoppingCart.css';

const SizeSelectionModal = ({ product, onAddToCart, onClose }) => {
  const [selectedSize, setSelectedSize] = useState(null);
  
  // Close modal when Escape key is pressed
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    
    document.addEventListener('keydown', handleEscKey);
    
    // Prevent scrolling of background content
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'auto';
    };
  }, [onClose]);
  
  const sizes = ['S', 'M', 'L', 'XL', 'XXL'];
  
  const handleAddToCart = () => {
    onAddToCart(product, selectedSize);
    onClose();
  };
  
  // Close modal when clicking outside
  const handleOverlayClick = (e) => {
    if (e.target.className === 'size-modal-overlay') {
      onClose();
    }
  };
  
  return (
    <div className="size-modal-overlay" onClick={handleOverlayClick}>
      <div className="size-modal">
        <h3>Select Size for {product.name}</h3>
        <div className="size-options">
          {sizes.map(size => (
            <div 
              key={size}
              className={`size-option ${selectedSize === size ? 'selected' : ''}`}
              onClick={() => setSelectedSize(size)}
            >
              {size}
            </div>
          ))}
        </div>
        <div className="size-modal-buttons">
          <button className="cancel-btn" onClick={onClose}>Cancel</button>
          <button 
            className="add-btn" 
            disabled={!selectedSize}
            onClick={handleAddToCart}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default SizeSelectionModal;
